import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: "The change in my son's confidence has been remarkable. The instructors are amazing with kids!",
  author: 'Sarah Jenkins',
  role: 'Parent of 7yo'
}, {
  text: 'Best decision we made for our family. Structured, safe, and incredibly supportive environment.',
  author: 'Mike Thompson',
  role: 'Parent of 10yo'
}, {
  text: "I've lost 20lbs and gained a new community. Watson Martial Arts is the real deal.",
  author: 'David Chen',
  role: 'Adult Student'
}];
export function TrustBadge() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-gray-50 border-y border-gray-100 py-8" data-id="element-124">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-126">
          {/* Google Rating */}
          <div className="flex items-center gap-4 bg-white px-6 py-3 rounded-lg shadow-sm border border-gray-100" data-id="element-127">
            <div className="flex flex-col" data-id="element-128">
              <div className="flex gap-1 text-yellow-400" data-id="element-129">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-current" data-id="element-130" />)}
              </div>
              <span className="text-xs font-bold text-gray-500 mt-1 uppercase tracking-wider" data-id="element-131">
                4.9/5 on Google (200+ Reviews)
              </span>
            </div>
            <img src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" alt="Google" className="w-8 h-8" data-id="element-132" />
          </div>

          {/* Testimonial Carousel */}
          <div className="flex-1 w-full max-w-2xl relative h-24 md:h-16 flex items-center justify-center md:justify-start" data-id="element-133">
            {testimonials.map((testimonial, idx) => <div key={idx} className={`absolute inset-0 transition-opacity duration-500 flex flex-col md:flex-row items-center md:items-start justify-center text-center md:text-left gap-2 ${idx === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} data-id="element-134">
                <p className="text-gray-800 font-medium italic" data-id="element-135">
                  "{testimonial.text}"
                </p>
                <div className="hidden md:block w-px h-8 bg-gray-300 mx-4" data-id="element-136"></div>
                <div className="flex flex-col items-center md:items-start min-w-[120px]" data-id="element-137">
                  <span className="font-bold text-gray-900 text-sm" data-id="element-138">
                    {testimonial.author}
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-139">
                    {testimonial.role}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Trust Line */}
          <div className="hidden lg:block text-sm font-semibold text-gray-400 uppercase tracking-widest" data-id="element-140">
            Trusted by 500+ Families
          </div>
        </div>
      </div>
    </div>;
}